
import React, { JSX } from 'react'
import { useParams } from 'react-router'
import { OverlayShell } from 'components/OverlayShell'
import { EmoteWallView } from 'components/EmoteWallView'
import { useOverlaySocketCredential } from 'hooks/useOverlaySocketCredential'

export const EmoteWallOverlayBody = ({
  emoteWallId,
  token
}: {
  emoteWallId: string
  token: string
}): JSX.Element => <EmoteWallView emoteWallId={emoteWallId} token={token} />

export const EmoteWallOverlayPage = (): JSX.Element => {
  const { emoteWallId } = useParams<{ emoteWallId: string }>()
  const token = useOverlaySocketCredential()

  if (emoteWallId == null || emoteWallId === '' || token == null || token === '') {
    return <OverlayShell>{null}</OverlayShell>
  }

  return (
    <OverlayShell>
      <EmoteWallOverlayBody emoteWallId={emoteWallId} token={token} />
    </OverlayShell>
  )
}
